import {createRoot} from 'react-dom/client'

import App from './App'

// @ts-ignore
const root = createRoot(document.getElementById('root'))
root.render(
    <App/>
)
